import authState from './auth/state';
import loadingState from './loading/state';
import sidebarState from './sidebar/state';

export default {
  ...authState,
  ...loadingState,
  ...sidebarState,
};
